import { useCallback } from 'react';

import type { AnyObject } from '../../../../../types';
import { bridge } from '../../../../../utils';
import { useAtomicScreen } from '../../../context/AtomicScreenContext';

export const useLogClickScrollableIconList = () => {
  const screen = useAtomicScreen();

  return useCallback(
    (logging: AnyObject) => {
      bridge.logAnalyticsEvent({
        name: 'CLICK_SCROLLABLE_ICON_LIST',
        analytics: {
          ...logging.analytics,
          ...(screen != null && { SCREEN: screen }),
        },
        ably_only_log: logging.ably_only_log,
      });
    },
    [screen],
  );
};
